import { useState } from "react";
import { useParams } from 'react-router-dom';
import { usePageTitle, useGetUnauthedDownload, triggerDownload, track } from '../../logic';
import { getPageUrl } from "../../utils";
import { ErrorDialog } from '../shared';
import { useOrganization } from "../OrganizationProvider";
import { UnauthedComponent } from "../shared/UnauthedComponent";

export function UnauthedDownloadPage({ drawerHeight }: {
  drawerHeight: number;
}) {
  usePageTitle('Welcome!');

  const { signingHash = '' } = useParams()
  const { CompanyDisplayName } = useOrganization()
  const [pinIsCorrect, setPinIsCorrect] = useState(false)

  const {
    isLoading: loading, error, mutate: mutateGetUnauthedDownload
  } = useGetUnauthedDownload(getPageUrl(), signingHash, {
    onSuccess(data) {
      setPinIsCorrect(true)
      startDownload(data.Url)
    },
    useErrorBoundary: false
  })

  function onSubmit(pin: string) {
    mutateGetUnauthedDownload({ Pin: pin })
  }

  function startDownload(downloadUrl: string) {
    track(`Unauthed Download initialized`, downloadUrl)

    const filename = `${CompanyDisplayName.replaceAll('.', '_')} - e-signing documents`

    triggerDownload(downloadUrl, filename).then(() => {
      // NOTE: This could be misleading since getting here doesn't reeaally mean it succeeded
      // IMPROVE: download file in a way that allows for confirming success
      track(`Unauthed download complete`, downloadUrl)
    })
  }

  return <>
    <UnauthedComponent drawerHeight={drawerHeight} onSubmit={onSubmit} loading={loading} pinIsCorrect={pinIsCorrect} text={'Download documents'} text2={'Download </br> your </br> e-signing </br> documents'}/>

    {/* ERROR DIALOG*/}
    {error && (
      // Using empty try again func to just close the dialog. In this case, trying
      // the same req again doesn't make sense, nor does reloading the page so it's
      // just a close button so they can double check their pin etc.
      <ErrorDialog onTryAgain={() => { }} tryAgainText="Close">
        We had an issue processing your request. Please try again or contact
        us for assistance.
      </ErrorDialog>
    )}

  </>
}
